import { render, staticRenderFns } from "./table-expand.vue?vue&type=template&id=8ca6252e"
import script from "./table-expand.vue?vue&type=script&lang=js"
export * from "./table-expand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports